import { render, staticRenderFns } from "./ProductTotalTrendChart.vue?vue&type=template&id=24024e5b&scoped=true"
import script from "./ProductTotalTrendChart.vue?vue&type=script&lang=js"
export * from "./ProductTotalTrendChart.vue?vue&type=script&lang=js"
import style0 from "./ProductTotalTrendChart.vue?vue&type=style&index=0&id=24024e5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24024e5b",
  null
  
)

export default component.exports